import { useMutation, useQuery } from "@tanstack/react-query";
import { randomBytes } from "crypto";
import { AuthContextValue, useAuth } from "../../providers/AuthProvider";
import axiosBaseURL from "..";

export const useInputListByCategory = (category: string) => {
  const { user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["inputs", category],
    staleTime: 12000,
    queryFn: async () => {
      // const result = await axiosBaseURL.get(`/inputs?category=${category}`, {
      //     headers: {
      //         header: `${user?.userId}/${user?.token}`,
      //         Authorization: authString,
      //     }
      // });
      return {
        status: "success",
        message: "message",
        length: 2,
        data: [
          {
            id: 1,
            category: "FERTILIZER",
            name: "DAP",
            unit: "kg",
          },
          {
            id: 2,
            category: "FERTILIZER",
            name: "Urea",
            unit: "kg",
          },
        ],
      };
    },
  });
};

export const useInputList = (searchKey?: string) => {
  const { user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["inputs"],
    staleTime: 120,
    queryFn: async () => {
      const result = await axiosBaseURL.get(`/operation/inputs`, {
        headers: {
          header: `${user?.userId}/${user?.token}`,
        },
      });
      return result;
    },
  });
};

export const useInputById = (id: string) => {
  const { user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["useInputById", id],
    staleTime: 120,
    enabled: false,
    queryFn: async () => {
      const result = await axiosBaseURL.get(`/operation/input?id=${id}`, {
        headers: {
          header: `${user?.userId}/${user?.token}`,
        },
      });

      return result;
    },
  });
};

// export const useInputCategoryList = () => {
//     return useQuery({
//         queryKey: ['categories'],
//         staleTime: 120,
//         queryFn: async () => {
//             const result = await supabase.rpc('admin_get_input_categories');

//             return result;
//         },
//     });
// }

export const useUnits = () => {
  const { user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["units"],
    staleTime: 12000,
    queryFn: async () => {
      // const result = await axiosBaseURL.get(`/units`, {
      //     headers: {
      //         header: `${user?.userId}/${user?.token}`,
      //         Authorization: authString,
      //     }
      // });
  // To be implemented from backend
      return {
        status: "success",
        message: "message",
        length: 3,
        data: ["kg", "kg/km", "lt", "pcs"],
      };
    },
  });
};

export const useInputListByContractId = (contractId: string) => {
  const { user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["input", contractId],
    staleTime: 120,
    queryFn: async () => {
      // const result = await axiosBaseURL.patch(`/contract${contractId}/input}`, {
      //     headers: {
      //         header: `${user?.userId}/${user?.token}`,
      //         Authorization: authString,
      //     }
      // });

      return {
        status: "success",
        message: "message",
        length: 4,
        data: [
          {
            id: 1,
            category: "FERTILIZER",
            name: "DAP",
            unit: "kg",
          },
          {
            id: 2,
            category: "FERTILIZER",
            name: "Urea",
            unit: "kg",
          },
        ],
      };
    },
  });
};

export const useInputListByOrderId = (orderId: string) => {
  const { user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["input", orderId],
    staleTime: 120,
    queryFn: async () => {
      // const result = await axiosBaseURL.patch(`/order${orderId}/input}`, {
      //     headers: {
      //         header: `${user?.userId}/${user?.token}`,
      //         Authorization: authString,
      //     }
      // });

      return {
        status: "success",
        message: "message",
        length: 4,
        data: [
          {
            id: 1,
            category: "FERTILIZER",
            name: "DAP",
            unit: "kg",
          },
          {
            id: 2,
            category: "FERTILIZER",
            name: "Urea",
            unit: "kg",
          },
          {
            id: 3,
            category: "SEED",
            name: "Potato",
            unit: "kg",
          },
          {
            id: 4,
            category: "SEED",
            name: "Tomato",
            unit: "kg",
          },
        ],
      };
    },
  });
};

export const useCreateInput = () => {
  const { user } = useAuth() as AuthContextValue;
  const { refetch } = useInputList();
  return useMutation({
    mutationFn: async (input: {
      category: string;
      name: string;
      measurementUnit: string;
      description: string;
    }) => {
      const result = await axiosBaseURL.post(`/operation/inputs`, input, {
        headers: {
          header: `${user?.userId}/${user?.token}`,
        },
      });

      refetch();
      return result;
    },
  });
};

export const useUpdateInput = () => {
  const { user } = useAuth() as AuthContextValue;
  const { refetch } = useInputList();
  return useMutation({
    mutationFn: async (data: {
      id: number;
      input: {
        category: string;
        name: string;
        measurementUnit: string;
        description: string;
      };
    }) => {
      const result = await axiosBaseURL.patch(
        `/operation/inputs/${data.id}`,
        data.input,
        {
          headers: {
            header: `${user?.userId}/${user?.token}`,
          },
        },
      );

      refetch();
      return data;
    },
  });
};

export const useDeleteInput = () => {
  const { user } = useAuth() as AuthContextValue;
  const { refetch } = useInputList();
  return useMutation({
    mutationFn: async (id: string) => {
      const result = await axiosBaseURL.delete(`/operation/inputs/${id}`, {
        headers: {
          header: `${user?.userId}/${user?.token}`,
        },
      });

      refetch();
      return result;
    },
  });
};

export const useAddInput = () => {
  const { user } = useAuth() as AuthContextValue;
  return useMutation({
    mutationFn: async (data: { inputId: number; contractId: number }) => {
      // const result = await axiosBaseURL.post(`/input`, data, {
      //     headers: {
      //         header: `${user?.userId}/${user?.token}`,
      //         Authorization: authString,
      //     }
      // });

      const _result = {
        status: "success",
        message: "message",
        data,
      };

      return _result;
    },
  });
};

export const useAddInputToOrder = () => {
  const { user } = useAuth() as AuthContextValue;
  return useMutation({
    mutationFn: async (data: { inputId: number; orderId: number }) => {
      // const result = await axiosBaseURL.post(`/order/${id}/input`, data, {
      //     headers: {
      //         header: `${user?.userId}/${user?.token}`,
      //         Authorization: authString,
      //     }
      // });

      const _result = {
        status: "success",
        message: "message",
        data,
      };

      return _result;
    },
  });
};
